import encodeChars from './encodeChars';

export default {
  multiple: true,
  encode(data, {name}) {
    const baseKey = encodeChars.colon(name);
    const baseVal = data.value;
    const results = [];
    if (baseVal.min) {
      results.push([`${baseKey}-min`, baseVal.min]);
    }
    if (baseVal.max) {
      results.push([`${baseKey}-max`, baseVal.max]);
    }
    return results;
  },
  decode(values, {settings}) {
    return {
      type: settings.type,
      value: values,
    };
  },
};
